import store from "./store";

export const SupplierImageStore = store("supplier");
export const ProductImageStore = store("product");
export const ClientImageStore = store("client");
export const SignatureImageStore = store("signature");

export { default as ImageGroup } from "./components/ImageGroup";
